import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Observable, Subscription } from 'rxjs';
import { Video } from '../../../../models/video.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { AuthService } from '../../../../services/auth.service';
import * as videoActions from '../../../../state/actions/video.actions';
import { AppState } from '../../../../state/appstate';
import * as videoSelector from '../../../../state/selectors/video.selector';

@Component({
  selector: 'app-my-videos',
  standalone: true,
  templateUrl: './my-videos.component.html',
  imports: [
    RouterModule,
    NgForOf,
    NgIf,
    AsyncPipe,
    NgxSkeletonLoaderModule,
    MomentPipe,
    InitialsPipe,
  ],
  styleUrls: ['./my-videos.component.css'],
})
export class MyVideosComponent implements OnInit, OnDestroy {
  videos$: Observable<Video[]> = new Observable();

  videoState$: Subscription = new Subscription();

  loading: boolean = true;

  constructor(
    private store: Store<AppState>,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.videoState$ = this.store
      .select((state) => state.videos)
      .subscribe((videos) => {
        this.loading = videos.loading;
        if (videos.ids.length == 0 && !videos.loaded && !videos.loading) {
          const uid: string | undefined = this.authService.getUid();
          if (uid) this.store.dispatch(videoActions.getVideos({ uid: uid! }));
        }
      });
    this.videos$ = this.store.pipe(select(videoSelector.getAllVideos));
  }

  ngOnDestroy(): void {
    this.videoState$.unsubscribe();
  }
}
